import { jsx as H } from "react/jsx-runtime";
const e = ({
  size: V
}) => {
  switch (V) {
    case "sm":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M4.87183 13.6304C4.53939 13.6304 4.25539 13.5127 4.01983 13.2773C3.78439 13.0417 3.66667 12.7577 3.66667 12.4253V3.96375H3V2.96375H6V2.37408H10V2.96375H13V3.96375H12.3333V12.4253C12.3333 12.762 12.2167 13.0471 11.9833 13.2804C11.75 13.5138 11.4649 13.6304 11.1282 13.6304H4.87183ZM11.3333 3.96375H4.66667V12.4253C4.66667 12.4851 4.68589 12.5343 4.72433 12.5728C4.76278 12.6112 4.81194 12.6304 4.87183 12.6304H11.1282C11.1795 12.6304 11.2265 12.609 11.2692 12.5663C11.3119 12.5236 11.3333 12.4766 11.3333 12.4253V3.96375ZM6.26933 11.2971H7.26917V5.29708H6.26933V11.2971ZM8.73083 11.2971H9.73067V5.29708H8.73083V11.2971Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M7.30775 20.4445C6.80908 20.4445 6.38308 20.2679 6.02975 19.9147C5.67658 19.5614 5.5 19.1354 5.5 18.6367V5.9445H4.5V4.4445H9V3.56H15V4.4445H19.5V5.9445H18.5V18.6367C18.5 19.1419 18.325 19.5695 17.975 19.9195C17.625 20.2695 17.1974 20.4445 16.6923 20.4445H7.30775ZM17 5.9445H7V18.6367C7 18.7266 7.02883 18.8003 7.0865 18.858C7.14417 18.9157 7.21792 18.9445 7.30775 18.9445H16.6923C16.7692 18.9445 16.8398 18.9124 16.9038 18.8482C16.9679 18.7842 17 18.7137 17 18.6367V5.9445ZM9.404 16.9445H10.9037V7.9445H9.404V16.9445ZM13.0962 16.9445H14.596V7.9445H13.0962V16.9445Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M6.08979 17.0375C5.67424 17.0375 5.31924 16.8903 5.02479 16.596C4.73049 16.3016 4.58333 15.9466 4.58333 15.531V4.95412H3.75V3.70412H7.5V2.96704H12.5V3.70412H16.25V4.95412H15.4167V15.531C15.4167 15.952 15.2708 16.3083 14.9792 16.6C14.6875 16.8916 14.3312 17.0375 13.9102 17.0375H6.08979ZM14.1667 4.95412H5.83333V15.531C5.83333 15.6059 5.85736 15.6673 5.90542 15.7154C5.95347 15.7634 6.01493 15.7875 6.08979 15.7875H13.9102C13.9744 15.7875 14.0331 15.7607 14.0865 15.7073C14.1399 15.6539 14.1667 15.5952 14.1667 15.531V4.95412ZM7.83667 14.1208H9.08646V6.62079H7.83667V14.1208ZM10.9135 14.1208H12.1633V6.62079H10.9135V14.1208Z",
          fill: "currentColor"
        }
      );
  }
}, r = ({
  size: V
}) => {
  switch (V) {
    case "sm":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M4.62501 14.1856C4.20523 14.1856 3.84751 14.0377 3.55184 13.7421C3.25617 13.4464 3.10834 13.0887 3.10834 12.6689V4.09391H2.35001V2.57724H5.91051V1.81891H10.0858V2.57724H13.6543V4.09391H12.896V12.6689C12.896 13.0887 12.7482 13.4464 12.4525 13.7421C12.1568 14.0377 11.7991 14.1856 11.3793 14.1856H4.62501ZM11.3793 4.09391H4.62501V12.6689H11.3793V4.09391ZM5.93051 11.3794H7.35551V5.37941H5.93051V11.3794ZM8.64884 11.3794H10.0738V5.37941H8.64884V11.3794Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M6.93727 21.2772C6.3076 21.2772 5.77102 21.0555 5.32752 20.612C4.88402 20.1685 4.66227 19.6319 4.66227 19.0022V6.13973H3.52477V3.86473H8.86552V2.72723H15.1285V3.86473H20.4813V6.13973H19.3438V19.0022C19.3438 19.6319 19.122 20.1685 18.6785 20.612C18.235 21.0555 17.6984 21.2772 17.0688 21.2772H6.93727ZM17.0688 6.13973H6.93727V19.0022H17.0688V6.13973ZM8.89552 17.068H11.033V8.06798H8.89552V17.068ZM12.973 17.068H15.1105V8.06798H12.973V17.068Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M5.78308 17.7315C5.25836 17.7315 4.81121 17.5467 4.44162 17.1771C4.07204 16.8075 3.88725 16.3604 3.88725 15.8356V5.11688H2.93933V3.22105H7.38996V2.27313H12.6091V3.22105H17.0697V5.11688H16.1218V15.8356C16.1218 16.3604 15.937 16.8075 15.5675 17.1771C15.1979 17.5467 14.7507 17.7315 14.226 17.7315H5.78308ZM14.226 5.11688H5.78308V15.8356H14.226V5.11688ZM7.41496 14.2238H9.19621V6.72376H7.41496V14.2238ZM10.8129 14.2238H12.5941V6.72376H10.8129V14.2238Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({
  size: V = "md",
  weight: C = "default"
}) => {
  switch (C) {
    case "bold":
      return /* @__PURE__ */ H(r, { size: V });
    case "book":
    case "default":
      return /* @__PURE__ */ H(e, { size: V });
  }
};
export {
  l as default
};
//# sourceMappingURL=DIconDelete.js.map
